<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="创建人编码" prop="creator">
        <el-input v-model="form.creator" placeholder="请输入创建人编码" v-trim/>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="form.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="更新人编码" prop="editor">
        <el-input v-model="form.editor" placeholder="请输入更新人编码" v-trim/>
      </el-form-item>
      <el-form-item label="更新时间" prop="editDate">
        <el-date-picker v-model="form.editDate" value-format="yyyy-MM-dd" placeholder="请输入更新时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="是否删除0否 1是" prop="isdeleted">
        <el-input v-model="form.isdeleted" placeholder="请输入是否删除0否 1是" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题" v-trim/>
      </el-form-item>
      <el-form-item label="简介" prop="info">
        <el-input v-model="form.info" placeholder="请输入简介" v-trim/>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <el-input v-model="form.content" placeholder="请输入内容" v-trim/>
      </el-form-item>
      <el-form-item label="关联对象编码" prop="objId">
        <el-input v-model="form.objId" placeholder="请输入关联对象编码" v-trim/>
      </el-form-item>
      <el-form-item label="关联对象类型 0工单" prop="objType">
        <el-input v-model="form.objType" placeholder="请输入关联对象类型 0工单" v-trim/>
      </el-form-item>
      <el-form-item label="关联对象名称" prop="objName">
        <el-input v-model="form.objName" placeholder="请输入关联对象名称" v-trim/>
      </el-form-item>
      <el-form-item label="类型 0工单上报 1工单分配物业主管 2SHE工单抄送  3工单处理催促 4工单分配处理人" prop="type">
        <el-input v-model="form.type" placeholder="请输入类型 0工单上报 1工单分配物业主管 2SHE工单抄送  3工单处理催促 4工单分配处理人" v-trim/>
      </el-form-item>
      <el-form-item label="关联参数1" prop="param1">
        <el-input v-model="form.param1" placeholder="请输入关联参数1" v-trim/>
      </el-form-item>
      <el-form-item label="关联参数2" prop="param2">
        <el-input v-model="form.param2" placeholder="请输入关联参数2" v-trim/>
      </el-form-item>
      <el-form-item label="关联参数3" prop="param3">
        <el-input v-model="form.param3" placeholder="请输入关联参数3" v-trim/>
      </el-form-item>
      <el-form-item label="关联参数4" prop="param4">
        <el-input v-model="form.param4" placeholder="请输入关联参数4" v-trim/>
      </el-form-item>
      <el-form-item label="关联参数5" prop="param5">
        <el-input v-model="form.param5" placeholder="请输入关联参数5" v-trim/>
      </el-form-item>
      <el-form-item label="关联用户姓名" prop="memberName">
        <el-input v-model="form.memberName" placeholder="请输入关联用户姓名" v-trim/>
      </el-form-item>
      <el-form-item label="关联用户企微编码" prop="qwId">
        <el-input v-model="form.qwId" placeholder="请输入关联用户企微编码" v-trim/>
      </el-form-item>
      <el-form-item label="关联用户编码（关联member)" prop="memberId">
        <el-input v-model="form.memberId" placeholder="请输入关联用户编码（关联member)" v-trim/>
      </el-form-item>
      <el-form-item label="关联企业组织编码(关联company）" prop="companyId">
        <el-input v-model="form.companyId" placeholder="请输入关联企业组织编码(关联company）" v-trim/>
      </el-form-item>
      <el-form-item label="状态 0正常 1已关闭" prop="status">
        <el-input v-model="form.status" placeholder="请输入状态 0正常 1已关闭" v-trim/>
      </el-form-item>
      <el-form-item label="是否抄送 0不是 1是" prop="sendacopy">
        <el-input v-model="form.sendacopy" placeholder="请输入是否抄送 0不是 1是" v-trim/>
      </el-form-item>
      <el-form-item label="是否已读 0未读 1已读" prop="readed">
        <el-input v-model="form.readed" placeholder="请输入是否已读 0未读 1已读" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaNoticesWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        remark: '',
        title: '',
        info: '',
        content: '',
        objId: '',
        objType: '',
        objName: '',
        type: '',
        param1: '',
        param2: '',
        param3: '',
        param4: '',
        param5: '',
        memberName: '',
        qwId: '',
        memberId: '',
        companyId: '',
        status: '',
        sendacopy: '',
        readed: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/notices',
      'field.id': 'id'
    })
  }
}
</script>
